import { Session } from "./session";
import { Ajax } from "../ajax";
import { Notifications } from "../notifications";
import { CenterCommission } from "./center-commission";
export class Form {
    constructor() {
        this.form = $("#add_sessions");
        this.sending = false;
        if (this.form.length === 0) {
            return;
        }
        this.session = new Session();
        this.url = this.form.attr("action");
        this.form.on("submit", (event) => event.preventDefault());
        this.form.find("#add_button").on("click", () => this.onButtonClicked());
        $("select:not(.select2)").select2();
        new CenterCommission();
    }
    onButtonClicked() {
        if (this.sending) {
            return;
        }
        this.sending = true;
        try {
            const { dates } = this.session;
            const center = this.session.centerValue;
            const prices = this.getPrices();
            const computerBased = this.getComputerBased();
            const oral = {
                start: dates.oralDate.start.formated,
                end: dates.oralDate.end.formated,
            };
            const data = {
                center,
                examDate: dates.sessionDate.formated,
                enrollmentDeadline: dates.enrollmentDeadline.formated,
                prices,
                computerBased,
                oral,
                useCenterLocation: this.session.useCenterLocation ? "1" : "0",
                useCenterCity: this.session.useCenterCity ? "1" : "0",
                address: this.session.addressValue,
                city: this.session.cityValue,
                maxQuota: this.session.maxQuota,
                serviceGroup: this.session.serviceGroup,
                statusId: this.session.status,
                currencyCode: this.session.currencyCode,
            };
            const ajax = new Ajax(this.url);
            ajax.data = data;
            ajax.successCallback = (data) => this.onSendingSuccess(data);
            ajax.errorCallback = (data) => this.onSendingError(data);
            ajax.send();
        }
        catch (e) {
            this.sending = false;
            Notifications.error(e.message);
            console.error(e.message);
        }
    }
    onSendingSuccess(data) {
        this.sending = false;
        if (!data.error) {
            Notifications.successCookie(sessionSaved, "");
            window.history.back();
        }
        this.enableForm();
    }
    onSendingError(data) {
        this.sending = false;
        this.enableForm();
    }
    enableForm() {
        this.form.find(":input").prop("disabled", false);
    }
    disableForm() {
        this.form.find(":input").prop("disabled", true);
    }
    getPrices() {
        const prices = [];
        for (const exam of this.session.exams.selectedExams.all) {
            prices.push(exam.price.ajaxObject);
        }
        if (prices.length === 0) {
            throw new Error(noPrices);
        }
        return prices;
    }
    getComputerBased() {
        const result = [];
        for (const exam of this.session.exams.selectedExams.all) {
            result.push(exam.computerBased.ajaxObject);
        }
        return result;
    }
}
